import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0) {
    if (!role || !allowedRoles.includes(role)) {
      if (role === "Admin") {
        return <Navigate to="/admin" replace />;
      } else {
        return <Navigate to="/home" replace />;
      }
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
